import { SubscriptionFeatureFlag } from '@mm/state/controllers/FeatureFlags';
import { CompanyLevelFeatureFlag } from '@mm/state/model/CompanyModel';
import { nextBillingTypeForFeatureSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import classnames from 'classnames';
import React, { MouseEvent, MutableRefObject, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import './TopLevelSidebarLink.pcss';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

type Props = {
  link?: string;
  onClick?: (e?: MouseEvent<HTMLDivElement>) => any;
  text?: string;
  isActive?: boolean;
  className?: string;
  iconComponent?: (isActive?: boolean) => ReactNode;
  requiredFeature?: SubscriptionFeatureFlag | CompanyLevelFeatureFlag;
  withExtendIcons?: boolean;
};

const TopLevelSidebarLink = React.forwardRef(
  (props: Props, ref: MutableRefObject<HTMLDivElement | null>) => {
    const {
      onClick,
      text,
      isActive,
      className,
      link,
      iconComponent,
      requiredFeature,
      withExtendIcons,
    } = props;

    const billingType = useSelector((state: StoreState) =>
      nextBillingTypeForFeatureSelector(state, requiredFeature),
    );
    const sidebarMinimized = useSelector(
      (state: StoreState) => state.chatbotSidebarState.isMinimized,
    );

    const titleWrapperClassList = classnames(
      'top-level-sidebar-link',
      className,
      {
        'top-level-sidebar-link--active-group-link': isActive,
        'top-level-sidebar-link--with-plan-badge': !!billingType,
      },
    );
    const extendIcons = !isActive ? (
      <PlusOutlined className="top-level-sidebar-link__extend-icon" />
    ) : (
      <MinusOutlined className="top-level-sidebar-link__extend-icon" />
    );

    if (link) {
      return (
        <a
          href={link}
          className={titleWrapperClassList}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="top-level-sidebar-link__title-text">{text}</div>
        </a>
      );
    }

    return (
      <div className={titleWrapperClassList} onClick={onClick} ref={ref}>
        <div className="top-level-sidebar-link__link-container">
          {iconComponent ? iconComponent(sidebarMinimized || isActive) : null}
          {!sidebarMinimized && (
            <div className="top-level-sidebar-link__title-text">{text}</div>
          )}
          {withExtendIcons && !sidebarMinimized && extendIcons}
        </div>
      </div>
    );
  },
);

export default TopLevelSidebarLink;
